import { useEffect, useState } from 'react';
import { toast } from './Toast';

export type NodePickCluster = { id: string; name: string };

type NodePicksProps = {

  id: string;

  clusters: NodePickCluster[];

  selectedIds: string[];

  onChange: (ids: string[]) => void;
  disabled?: boolean;
};





export function NodePicks({ id, clusters, selectedIds, onChange, disabled }: NodePicksProps) {
  const clusterIds = clusters.map((c) => c.id);
  const syncKey = `${selectedIds.join('|')}#${clusterIds.join('|')}`;

  const [allOn, setAllOn] = useState(selectedIds.length === 0);
  const [nodes, setNodes] = useState<Set<string>>(
    () => new Set(selectedIds.length ? selectedIds : clusterIds),
  );

  useEffect(() => {
    setAllOn(selectedIds.length === 0);
    setNodes(new Set(selectedIds.length ? selectedIds : clusterIds));
  }, [syncKey]);

  const commit = (nextAll: boolean, nextNodes: Set<string>, rollback: () => void) => {
    if (nextAll) {
      onChange([]);
      return;
    }
    const ids = clusterIds.filter((cid) => nextNodes.has(cid));
    if (!ids.length) {
      toast('Выберите хотя бы одну ноду или отметьте «Все», иначе задаче негде будет выполняться.', 'wa');
      rollback();
      return;
    }
    onChange(ids);
  };

  const toggleAll = (checked: boolean) => {
    const prevAll = allOn;
    const prevNodes = nodes;
    if (checked) {
      const next = new Set(clusterIds);
      setAllOn(true);
      setNodes(next);
      commit(true, next, () => undefined);
    } else {
      setAllOn(false);
      commit(false, nodes, () => {
        setAllOn(prevAll);
        setNodes(prevNodes);
      });
    }
  };

  const toggleNode = (nodeId: string, checked: boolean) => {
    const prevAll = allOn;
    const prevNodes = nodes;
    const next = new Set(nodes);
    if (checked) next.add(nodeId);
    else next.delete(nodeId);
    const nextAll = clusterIds.length > 0 && clusterIds.every((cid) => next.has(cid));
    setNodes(next);
    setAllOn(nextAll);
    commit(nextAll, next, () => {
      setAllOn(prevAll);
      setNodes(prevNodes);
    });
  };

  return (
    <div id={id} className="node-picks">
      <label className="node-pick">
        <input
          type="checkbox"
          data-all="1"
          checked={allOn}
          disabled={disabled}
          onChange={(e) => toggleAll(e.target.checked)}
        />
        <span>Все</span>
      </label>
      {clusters.length ? (
        clusters.map((c) => (
          <label className="node-pick" key={c.id}>
            <input
              type="checkbox"
              data-node={c.id}
              checked={allOn || nodes.has(c.id)}
              disabled={disabled}
              onChange={(e) => toggleNode(c.id, e.target.checked)}
            />
            <span>{c.name}</span>
          </label>
        ))
      ) : (
        <span className="hint">Нет включённых нод</span>
      )}
    </div>
  );
}
